import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * SmoothScroll — Lenis-powered buttery smooth scrolling, plus a global
 * scroll progress bar at the top of the viewport. Adds an instant
 * premium feel to the entire site.
 */
const SmoothScroll = () => {
  useEffect(() => {
    // Don't init on mobile (browser native is better there)
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    if (isTouchDevice) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const rafId = requestAnimationFrame(raf);

    // Update progress bar based on scroll
    const onScroll = () => {
      const bar = document.getElementById('scroll-progress-bar');
      if (!bar) return;
      const scrolled = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (scrolled / max) * 100 : 0;
      bar.style.transform = `scaleX(${pct / 100})`;
    };
    lenis.on('scroll', onScroll);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[2px] z-[9999] pointer-events-none"
      aria-hidden="true"
    >
      <div
        id="scroll-progress-bar"
        className="h-full origin-left"
        style={{
          background: 'linear-gradient(90deg, #FF6B00 0%, #FFB400 50%, #FF6B00 100%)',
          transform: 'scaleX(0)',
          transition: 'transform 0.05s linear',
          boxShadow: '0 0 12px rgba(255,107,0,0.6)',
        }}
      />
    </div>
  );
};

export default SmoothScroll;
